<template>  
<div>
    <div class="clearfix">
        <div class="header-left">
            <div class="hederLeft clearfix">
               <div class="headerLogo"><router-link :to="{name:'index'}"><img src="@/assets/logo01.png"><h3>医师定期考核培训课程</h3></router-link></div>
            </div>
        </div>
        <div class="header-right">
            <div class="headerAccount">
                <div v-if="!this.$store.state.isLogin">
                    <div class="hederLogin" ><router-link :to="{name:'login'}">登录</router-link></div>
                    <div class="hederRegister"><router-link :to="{name:'register'}">注册</router-link></div>
                </div>
                <div v-else class="compLogin">
                    <span>欢迎您，<router-link :to="{name:'userCenter'}">{{this.$store.state.userName}}</router-link></span>|<strong @click="exitLogin">[ 退出 ]</strong>
                </div>    
           </div>
        </div>
    </div>
    <div class="servicePage">
        <div class="servicePageListArea01" v-if="itemdata.isTrue">
            <router-link v-if="itemdata.isButton" :to="{name:'areaCourseList',params:{id:'all',areaid:searveId}}">
                <!-- <el-image :src="itemdata.listImgUrl">
                    <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                    </div>
                </el-image> -->
                <div class="weimg">
                    <img :src="itemdata.listImgUrl">
                </div>
                <div class="toolsTile">我要培训</div>
            </router-link>
        </div>
    </div>
</div>
</template>
<script>
import api from "@/api/index.js";
export default{
    
    data() {
      return {
        searveId:'',
        searveName:'',
        itemdata:[],
        serverData:[
                {
                    listTitle:'',
                    typeId:'AreaCity',
                    listImgUrl:require('@/assets/areaBackground.png'),
                    ListName:'',
                    isTrue:true,
                    isButton:true,
                    data:[
                        {
                            id:'0001',
                            title:'医师定期考核信息管理系统',
                            conTitle:'医师定期考核信息管理系统',
                            conText:'承担《医师定考》规定的“考核办公室”“卫生机构”“考核机构”“执业医师”四个业务角色的职能服务。符合《医师定考》规范：定考业务流程、定考考核流程。完善的六大功能模块：基础信息、账号管理、定考管理、定考信息、历史信息、统计分析',
                            imgUrl:require('@/assets/images/toolsItem01.png'),
                        },
                    ],
                },
            ],
      };
    },
    created(){
        this.searveId=this.$route.params.id;
        //this.searveName=this.$route.query.name;
        console.log(this.searveId);

        var then=this;
        this.serverData.forEach(function (item,index){
             then.itemdata=item
        })
    },
    beforeMount(){
        
    },
    methods: {
      handleClick(tab, event) {
        // console.log(tab, event);
      },
      exitLogin(){
        api.loginOut()
            .then(res=>{
                console.log(res);
                if(res.data.Status==1){
                    this.$store.commit("setUserName",'')
                    localStorage.setItem('setCourseListUrl','')
                    this.$store.commit("changeLogin",false)
                    this.$store.commit('del_token')
                    this.$router.push({name:'index'});
                    this.$message({
                    message:'你已经成功退出登陆状态',
                    type: 'success',
                  });
                }else{
                    this.$message({
                    message:'退出失败',
                    type: 'success',
                  });
                }
            }).then(res=>{
                // this.$store.commit('del_token')
            })
        // this.$store.commit('del_token');
      }
    }
}

</script>
<style>
.header-left{ float: left;}
.header-right{ float: right;}
.hederLeft{ height: 78px;}
.headerLogo{ float: left;height: 78px; line-height: 78px;margin-left: 30px;}
.headerLogo img{float: left;  margin-right: 40px;  vertical-align: middle;}
.headerLogo h3{float: left; line-height: 78px; font-size: 36px;color: gray;vertical-align: middle;}
.hederLogin,.hederRegister{ float: left; font-size: 14px; margin-top: 30px; margin-left: 10px;}
.hederLogin a{padding:5px 15px; background-color:#0e6eb8; color:#fff; border-radius: 5px; border:1px solid #0e6eb8}
.hederLogin a:hover{ color: #fff;}
.headerAccount{float: right;margin-right: 30px;}
.hederRegister a{padding:5px 15px; background-color:#fff; color:#333; border-radius: 5px;border:1px solid #ccc;}
.hederRegister a:hover{ background: #ecf5ff; color: #fff;}
.compLogin{ line-height: 78px; font-size: 14px;}
.compLogin span{}
.compLogin a{ color: #0e6eb8; margin-right: 5px;}
.compLogin strong{ font-weight: normal ;margin-left:5px; color:#999;}
.compLogin strong:hover{ color: #0e6eb8; cursor: pointer;}
.servicePageListArea01{ background: #3f62b9;}
.toolsAeaTile{ font-size: 24px; font-weight: normal; text-align: center; padding:-40px 0 40px 0;}
.toolsAeaTile a{ display: block; margin-top:20px;width: 140px;border-radius:5px;font-size: 18px; text-align: center; height: 42px; line-height: 42px; background-color: #f9a709; color: #fff;-moz-box-shadow:0px 0px 10px #999; -webkit-box-shadow:0px 0px 10px #999; box-shadow:0px 0px 10px #999;}
.toolsAeaTile a:hover{ background-color: #fcba3a; color: #fff;}
.weimg{ text-align: center;}
.toolsTile{font-size: 24px;
    text-align: center;
    color: #f9a709;
    display: block;
    margin: -62px 0 0 -70px;
    width: 140px;
    left: 50%;
    position: absolute;
    padding:0;
    border-radius: 5px;
    font-size: 18px;
    text-align: center;
    height: 42px;
    line-height: 42px;
    background-color: #f9a709;
    color: #fff;
    -webkit-box-shadow: 0px 0px 10px #999;
    box-shadow: 0px 0px 10px #999;}
.servicePageListArea01 a{ display: block; width: 100%;}
</style>